import React, { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import { FaFileInvoice, FaCalendarAlt, FaDollarSign, FaSpinner } from 'react-icons/fa';
import './InvoiceManagement.css';

function InvoiceManagement() {
  const [upcomingInvoice, setUpcomingInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUpcomingInvoice();
  }, []);

  const fetchUpcomingInvoice = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/paywall/subscriptions/upcoming-invoice');
      setUpcomingInvoice(response.data);
    } catch (error) {
      if (error.response?.status !== 404) {
        console.error('Error fetching upcoming invoice:', error);
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatAmount = (amount, currency = 'USD') => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="invoice-management">
        <div className="loading-state">
          <FaSpinner className="spin" />
          <span>Loading invoice information...</span>
        </div>
      </div>
    );
  }

  if (!upcomingInvoice) {
    return null; // No upcoming invoice to display
  }

  return (
    <div className="invoice-management">
      <div className="invoice-header">
        <h3><FaFileInvoice /> Upcoming Invoice</h3>
        <p className="invoice-subtitle">Your next billing cycle</p>
      </div>

      <div className="invoice-summary">
        <div className="summary-item">
          <FaCalendarAlt className="summary-icon" />
          <div>
            <h4>Next Billing Date</h4>
            <p>{formatDate(upcomingInvoice.period_end)}</p>
          </div>
        </div>
        
        <div className="summary-item total">
          <FaDollarSign className="summary-icon" />
          <div>
            <h4>Total Due</h4>
            <p className="amount">{formatAmount(upcomingInvoice.amount, upcomingInvoice.currency)}</p>
          </div>
        </div>
      </div>

      {upcomingInvoice.lines && upcomingInvoice.lines.length > 0 && (
        <div className="invoice-details">
          <h4>Line Items</h4>
          <div className="line-items">
            {upcomingInvoice.lines.map((line, index) => (
              <div key={index} className="line-item">
                <div className="line-description">
                  <span className="description">{line.description}</span>
                  <span className="period">
                    {formatDate(line.period.start)} - {formatDate(line.period.end)}
                  </span>
                </div>
                <div className="line-amount">
                  {formatAmount(line.amount, upcomingInvoice.currency)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="invoice-note">
        <p>
          This invoice will be automatically charged to your default payment method on file. 
          You'll receive an email receipt after payment is processed.
        </p>
      </div>
    </div>
  );
}

export default InvoiceManagement;